__webpack_require__.p = "https://gsp-1258344701.file.myqcloud.com/caidata_admin/build/";